<template>
  <img :src="imgSrc" :alt="description" />
</template>

<script>
  export default {
    props: ['imgSrc', 'description']
  }
</script>

<style scoped>
  img {
    width: 130px;
    padding-top: 30px;
  }
</style>